import { handleActions } from "redux-actions";
import {
    addSupplierSuccess,
    deleteSupplierbSuccess,
    setCountSuppliers,
    setSuppliers,
    updateSupplierSuccess
} from "../action";

const initialState = {
    items: [],
    error: null,
    loading: false,
    count: 0,
};

const suppliers = handleActions(
    {
        [setSuppliers]: (state, { payload }) => ({
            ...state,
            items: payload,
        }),
        [setCountSuppliers]: (state, { payload }) => ({
            ...state,
            count: payload,
        }),
        [deleteSupplierbSuccess]: (state, { payload: id }) => ({
            ...state,
            items: state.items.filter((supplier) => supplier.id !== id),
        }),
        [addSupplierSuccess]: (state, { payload }) => ({
            ...state,
            items: [...state.items, payload],
        }),
        [updateSupplierSuccess]: (state, { payload }) => ({
            ...state,
            items: state.items.map(item =>
                item.id === payload.id ? payload : item
            ),
        }),
        'SET_LOADER': (state, action) => {
            if (action.field === 'suppliers') {
                return { ...state, loading: action.value };
            }
            return state;
        },
    },
    initialState
);

export default suppliers;
